export const handlerErrorV2 = (err) => {
  console.error(err)
  const { response } = err
  console.error(response)

  if (response?.data) {
    const { error } = response.data
    return error?.message || 'Something went wrong. Please try again.'
  }
  console.error('Error: ', err.message)
  return err.message || 'Something went wrong. Please try again.'
}

/**
 * This function validate if the income object is valid again the 
 @param {String} code - code http
 @param {String} type - messageType
 @param {array} data - If code >= 400 && code < 500, it returns an array with the keys where the validation found error
 */

const handlerError = (code, type, data, message) => {
    let resp = {
        type: 'common',
        data: {
            title: 'Unable to connect to the internet',
            icon: ["fas","wifi-slash"],
            type, disabledCloseButton: false,
            form: {}
        }
    }
    if (code === 403) {
        resp.data.title = 'Invalid token'
        resp.data.type = 'InvalidToken'
        resp.data.icon =  ["fas","exclamation-triangle"]
    } else if (code >= 400 && code < 500) {
        if (type === "UnAuthorized") {
            resp.data.title =  'Not authorized'
            resp.data.icon = 'ban'
            resp.data.disabledCloseButton = true
            if (message === 'UnAuthorizedImpersonate') {
                resp.data.title =  'Changes cannot be saved during and impersonation session'
                resp.data.disabledCloseButton = false
                resp.data.type = message        
            }
        } else if (type === "SessionExpired") {
            resp.data.title = message
            resp.data.icon =  ["fas","exclamation-triangle"]
            resp.data.disabledCloseButton = true
        } else if (type === "NotMatch") {
            resp.type = 'form'
            data.forEach((key) => { 
                resp.data[key] = 'The field does not match.'
            })
        } else if (type === "Duplicate") {
            resp.type = 'form'
            if(Array.isArray(data))  {
                data.forEach((key) => {
                    resp.data.form[key] = data[key] 
                })
            } else {
                resp.data.form = data
            }

        } else if (type === "Validation") {
            if (data.error === "Lcs used in other Developmental Rubrics") {
                resp.type = 'lcInUsed'
                resp.data.icon =  ["fas","exclamation-triangle"]
                resp.data.title =  data.error 
            } else if (data.error === "Learning continua is being used by at least one Developmental rubric.") {
                resp.type = 'lcInUsed'
                resp.data.icon =  ["fas","exclamation-triangle"]
                resp.data.title =  data.error 
                resp.data.data =  data.data 
            } else if (data.error && data.error.indexOf("Empty variable") > -1) {
                resp.type = 'form'
                resp.data.icon =  ["fas","exclamation-triangle"]
                resp.data.title =  'Empty variable' 

                Object.keys(data.data).forEach((key) => {
                    if (data.data[key]) {
                        resp.data[key] = 'The field is required.'  
                        resp.data.form[key] = 'The field is required.'  
                    }
                })
            } else {
                resp.type = 'form'
                
                if (Array.isArray(data)) {
                    data.forEach((key) => {
                        resp.data[key] = 'The field is required.'  
                    })
                }

                if (data.data) {
                    resp.data = data.data
                }
            }
        } else if (type === "Empty") {
            if (message === 'Invalid refresh token') {
                resp.data.title = message
                resp.data.icon =  'sign-out-alt'
                resp.data.type =  'LOGOUT'
                resp.data.disabledCloseButton = true
            }
        } else if (type === "NotExecuted") {
            resp.data.title = message
            resp.data.icon =  ["fas","exclamation-triangle"]
            if (message === 'Can not execute this action, becuase unit of learning assigned') {
                const codes = data.data.classes.map((item) => item.code)
                resp.data.title = <div>
                    <b>Class{codes.length === 1 ? '' : 'es'} {codes.join(', ')} cannot be edited.</b>
                    <p style={{ textTransform: 'none', fontWeight: 'normal' }}>Units of Learnings are assigned</p>
                </div>
            }
            if (message === 'Can not execute this action, becuase classes are from different learing area or discipline ') {
                const codes = data.data.classes.map((item) => item.code)
                resp.data.title = <div>
                    <b>Class{codes.length === 1 ? '' : 'es'} {codes.join(', ')} cannot be edited.</b>
                    <p style={{ textTransform: 'none', fontWeight: 'normal' }}>classes are from different learing area or discipline </p>
                </div>
            }
        }   
    } else if (code === 504 || code === 502) {
        resp.data.title =  'Server connection lost'
        resp.data.icon =  'ghost'
    }

    return resp
}
  
export {
    handlerError
}